const config = {
    'SERVICE_URL_PREFIX': 'https://corpushub.kuaiman.com/api/v1',
}

export default config;
